import OrderingCatalogService from "@/services/OrderingCatalogService";

const rejectApiError = (error) => Promise.reject(error.response?.data || error);

export const orderingCatalog = {
  namespaced: true,
  actions: {
    getStores() {
      return OrderingCatalogService.GetStores().catch(rejectApiError);
    },
    getGroups() {
      return OrderingCatalogService.GetGroups().catch(rejectApiError);
    },
    getProducts(context, payload) {
      return OrderingCatalogService.GetProducts(
        payload.storeId,
        payload.params
      ).catch(rejectApiError);
    },
    saveProduct(context, payload) {
      return OrderingCatalogService.SaveProduct(
        payload.storeId,
        payload.productId,
        payload.data
      ).catch(rejectApiError);
    },
    setBulkPublication(context, payload) {
      return OrderingCatalogService.SetBulkPublication(
        payload.storeId,
        payload.data
      ).catch(rejectApiError);
    },
  },
};
